function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as log from '../../log';
import { uniqueId } from '../../util';
/**
 * A node in the dataflow tree.
 */
export var DataFlowNode = /*#__PURE__*/function () {
  function DataFlowNode(parent, debugName) {
    _classCallCheck(this, DataFlowNode);
    this.debugName = debugName;
    this._children = [];
    this._parent = null;
    if (parent) {
      this.parent = parent;
    }
  }
  /**
   * Clone this node with a deep copy but don't clone links to children or parents.
   */
  return _createClass(DataFlowNode, [{
    key: "clone",
    value: function clone() {
      throw new Error('Cannot clone node');
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    }
    /**
     * Set the parent of the node and also add this node to the parent's children.
     */,
    set: function set(parent) {
      this._parent = parent;
      if (parent) {
        parent.addChild(this);
      }
    }
  }, {
    key: "children",
    get: function get() {
      return this._children;
    }
  }, {
    key: "numChildren",
    value: function numChildren() {
      return this._children.length;
    }
  }, {
    key: "addChild",
    value: function addChild(child, loc) {
      // do not add the same child twice
      if (this._children.includes(child)) {
        log.warn(log.message.ADD_SAME_CHILD_TWICE);
        return;
      }
      if (loc !== undefined) {
        this._children.splice(loc, 0, child);
      } else {
        this._children.push(child);
      }
    }
  }, {
    key: "removeChild",
    value: function removeChild(oldChild) {
      var loc = this._children.indexOf(oldChild);
      this._children.splice(loc, 1);
      return loc;
    }
    /**
     * Remove node from the dataflow.
     */
  }, {
    key: "remove",
    value: function remove() {
      var loc = this._parent.removeChild(this);
      var _iterator = _createForOfIteratorHelper(this._children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          // do not use the set method because we want to insert at a particular location
          child._parent = this._parent;
          this._parent.addChild(child, loc++);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Insert another node as a parent of this node.
     */
  }, {
    key: "insertAsParentOf",
    value: function insertAsParentOf(other) {
      var parent = other.parent;
      parent.removeChild(this);
      this.parent = parent;
      other.parent = this;
    }
  }, {
    key: "swapWithParent",
    value: function swapWithParent() {
      var parent = this._parent;
      var newParent = parent.parent;
      // reconnect the children
      var _iterator2 = _createForOfIteratorHelper(this._children),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          child.parent = parent;
        }
        // remove old links
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this._children = []; // equivalent to removing every child link one by one
      parent.removeChild(this);
      var loc = parent.parent.removeChild(parent);
      // swap two nodes but maintain order in children
      this._parent = newParent;
      newParent.addChild(this, loc);
      parent.parent = this;
    }
  }]);
}();
export var OutputNode = /*#__PURE__*/function (_DataFlowNode) {
  /**
   * @param source The name of the source. Will change in assemble.
   * @param type The type of the output node.
   * @param refCounts A global ref counter map.
   */
  function OutputNode(parent, source, type, refCounts) {
    var _this;
    _classCallCheck(this, OutputNode);
    _this = _callSuper(this, OutputNode, [parent, source]);
    _this.type = type;
    _this.refCounts = refCounts;
    _this._source = _this._name = source;
    if (_this.refCounts && !(_this._name in _this.refCounts)) {
      _this.refCounts[_this._name] = 0;
    }
    return _this;
  }
  _inherits(OutputNode, _DataFlowNode);
  return _createClass(OutputNode, [{
    key: "clone",
    value: function clone() {
      var cloneObj = new this.constructor();
      cloneObj.debugName = "clone_".concat(this.debugName);
      cloneObj._source = this._source;
      cloneObj._name = "clone_".concat(this._name);
      cloneObj.type = this.type;
      cloneObj.refCounts = this.refCounts;
      cloneObj.refCounts[cloneObj._name] = 0;
      return cloneObj;
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set();
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set();
    }
  }, {
    key: "hash",
    value: function hash() {
      if (this._hash === undefined) {
        this._hash = "Output ".concat(uniqueId());
      }
      return this._hash;
    }
    /**
     * Request the datasource name and increase the ref counter.
     *
     * During the parsing phase, this will return the simple name such as 'main' or 'raw'.
     * It is crucial to request the name from an output node to mark it as a required node.
     * If nobody ever requests the name, this datasource will not be instantiated in the assemble phase.
     *
     * In the assemble phase, this will return the correct name.
     */
  }, {
    key: "getSource",
    value: function getSource() {
      this.refCounts[this._name]++;
      return this._source;
    }
  }, {
    key: "isRequired",
    value: function isRequired() {
      return !!this.refCounts[this._name];
    }
  }, {
    key: "setSource",
    value: function setSource(source) {
      this._source = source;
    }
  }]);
}(DataFlowNode);